import React from "react";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

import { messages } from "../../VirtualAcoustics.messages";
import styles from "./Slide1.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { nl2p } from "@src/utils/nl2p";

export const Slide1: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <SimpleLayoutView>
      <div className={styles.root}>
        <div className={styles.rightComponent}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
          <SpatialCarousel showBreadcrumbs>
            {[
              <div key={1} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G6_P5_S1_S1_Title)}</h3>
                <p>{formatMessage(messages.G6_P5_S1_S1_Description_P1)}</p>
                <p className={styles.quote}>{formatMessage(messages.G6_P5_S1_S1_Description_Quote)}</p>
                <p className={styles.note}>{formatMessage(messages.G6_P5_S1_S1_Description_Note)}</p>
                <p>{formatMessage(messages.G6_P5_S1_S1_Description_P2)}</p>
              </div>,
              <div key={2} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G6_P5_S1_S2_Title)}</h3>
                <p>{formatMessage(messages.G6_P5_S1_S2_Description_P1)}</p>

                <ul>
                  <li>{formatMessage(messages.G6_P5_S1_S2_Description_L1)}</li>
                  <li>{formatMessage(messages.G6_P5_S1_S2_Description_L2)}</li>
                  <li>{formatMessage(messages.G6_P5_S1_S2_Description_L3)}</li>
                  <li>{formatMessage(messages.G6_P5_S1_S2_Description_L4)}</li>
                  <li>{formatMessage(messages.G6_P5_S1_S2_Description_L5)}</li>
                  <li>{formatMessage(messages.G6_P5_S1_S2_Description_L6)}</li>
                  <li>{formatMessage(messages.G6_P5_S1_S2_Description_L7)}</li>
                </ul>

                <p>{formatMessage(messages.G6_P5_S1_S2_Description_P2)}</p>
                <p>{nl2p(formatMessage(messages.G6_P5_S1_S2_Description_Note))}</p>
              </div>,
            ]}
          </SpatialCarousel>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
